import { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { RefreshCwIcon } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/common/components/ui/dialog';
import { Button } from '@/common/components/ui/button';
import { BUILD_OUTDATED_EVENT } from '@/features/build-version/interceptors/buildVersionInterceptor';

export function OutdatedBuildDialog() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(BUILD_OUTDATED_EVENT, handler);
    return () => window.removeEventListener(BUILD_OUTDATED_EVENT, handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            <Trans>Application update available</Trans>
          </DialogTitle>
          <DialogDescription>
            <Trans>
              A new version of the application is available. Please reload the page to continue.
            </Trans>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => window.location.reload()}>
            <RefreshCwIcon aria-hidden="true" />
            <Trans>Reload</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
